import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles(() => ({
  article: {
    padding: '0.5rem 0.75rem',
    display: 'grid',
    columnGap: '0.5rem',
    alignItems: 'center',
    gridTemplateColumns: '1fr auto',
    color: neutral['70'],
    cursor: 'pointer',
    borderRadius: '0.5rem',
    animationName: '$pulse',
    animationDuration: '1s',
    animationFillMode: 'both',
    animationIterationCount: 'infinite',
    '&[data-has-turbotag="true"]': {
      paddingTop: '1.5rem',
    },
  },
  section: {
    display: 'flex',
    gap: '0.25rem',
    flexDirection: 'column',
  },
  status: {
    textAlign: 'right',
    textTransform: 'uppercase',
  },
  oId: {
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: '1.5rem',
    color: neutral['100'],
  },
  storeName: {
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
  },
  turboTag: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  '@keyframes pulse': {
    from: {
      transform: 'scale3d(1, 1, 1)',
    },
    '50%': {
      transform: 'scale3d(1.05, 1.05, 1.05)',
    },
    to: {
      transform: 'scale3d(1, 1, 1)',
    },
  },
}));
